import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useEffect, useRef } from 'react';
import { RadioButton } from './index';
import styles from './styles';
import { Text, View, Animated } from 'react-native';
import ArrowUpBlack from '../../../assets/images/rn/ArrowUpBlack';
var SingleRadioWithSubOptions = function SingleRadioWithSubOptions(props) {
  var _ref, _opt$subOptions, _opt$subOptions5;
  var opt = props.opt,
    value = props.value,
    name = props.name,
    disabled = props.disabled,
    onChange = props.onChange,
    active = props.active;
  var rotation = useRef(new Animated.Value(0)).current;
  var onExpandClick = function onExpandClick(active) {
    var toValue = active ? 0 : 180;
    Animated.timing(rotation, {
      toValue: toValue,
      duration: 300,
      useNativeDriver: true
    }).start();
  };
  useEffect(function () {
    onExpandClick(active);
  }, [active]);
  var rotateStyle = {
    transform: [{
      rotate: rotation.interpolate({
        inputRange: [0, 180],
        outputRange: ['0deg', '180deg']
      })
    }]
  };
  return /*#__PURE__*/React.createElement(View, null, ((_ref = (opt === null || opt === void 0 ? void 0 : opt.subOptions) || []) === null || _ref === void 0 ? void 0 : _ref.length) > 0 && /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(RadioButton, _extends({}, opt, {
    textStyle: opt.textStyle,
    key: opt.value,
    name: name,
    label: opt.label || opt.value,
    customBtnElement: /*#__PURE__*/React.createElement(View, {
      style: styles['radio-with-subOptions']
    }, /*#__PURE__*/React.createElement(Text, {
      style: [styles['radio-with-subOptions-text'], opt.textStyle]
    }, opt.label || opt.value), /*#__PURE__*/React.createElement(Animated.View, {
      style: rotateStyle
    }, /*#__PURE__*/React.createElement(ArrowUpBlack, null))),
    value: opt.value,
    checked: ((_opt$subOptions = opt.subOptions) === null || _opt$subOptions === void 0 ? void 0 : _opt$subOptions.findIndex(function (subOpt) {
      return subOpt.value === value;
    })) !== -1,
    disabled: 'disabled' in opt ? opt.disabled : disabled // 父选项的值不设置为value
    ,

    onClick: function onClick(e) {
      var _opt$subOptions2;

      // 如果已有选中的子选项
      if (((_opt$subOptions2 = opt.subOptions) === null || _opt$subOptions2 === void 0 ? void 0 : _opt$subOptions2.findIndex(function (subOpt) {
        return subOpt.value === value;
      })) !== -1) {
        var _opt$subOptions3, _opt$subOptions3$find;
        onChange((_opt$subOptions3 = opt.subOptions) === null || _opt$subOptions3 === void 0 ? void 0 : (_opt$subOptions3$find = _opt$subOptions3.find(function (subOpt) {
          return subOpt.value === value;
        })) === null || _opt$subOptions3$find === void 0 ? void 0 : _opt$subOptions3$find.value, e);
      } else {
        var _opt$subOptions4, _opt$subOptions4$;

        // 默认选中第一个
        onChange((_opt$subOptions4 = opt.subOptions) === null || _opt$subOptions4 === void 0 ? void 0 : (_opt$subOptions4$ = _opt$subOptions4[0]) === null || _opt$subOptions4$ === void 0 ? void 0 : _opt$subOptions4$.value, e);
      }
    }
  })), active && (opt === null || opt === void 0 ? void 0 : (_opt$subOptions5 = opt.subOptions) === null || _opt$subOptions5 === void 0 ? void 0 : _opt$subOptions5.map(function (subOpt) {
    return /*#__PURE__*/React.createElement(RadioButton, _extends({}, subOpt, {
      containerStyle: _objectSpread(_objectSpread({}, styles['sub-options']), subOpt.containerStyle),
      isCheckMark: true,
      isButtonRight: true,
      textStyle: subOpt.textStyle,
      key: subOpt.value,
      name: name,
      label: subOpt.label || subOpt.value,
      value: subOpt.value,
      checked: value === subOpt.value,
      disabled: 'disabled' in subOpt ? subOpt.disabled : disabled,
      onClick: function onClick(e) {
        onChange(subOpt.value, e);
      }
    }));
  }))));
};
export var RadioGroup = function RadioGroup(props) {
  var _props$layout = props.layout,
    layout = _props$layout === void 0 ? 'horizontal' : _props$layout,
    options = props.options,
    value = props.value,
    name = props.name,
    disabled = props.disabled,
    onChange = props.onChange,
    containerStyle = props.containerStyle;
  return /*#__PURE__*/React.createElement(View, {
    style: [styles['radio-group'], styles["radio-group__".concat(layout)], containerStyle]
  }, options.map(function (opt) {
    var _ref2, _opt$subOptions6;
    return /*#__PURE__*/React.createElement(View, {
      key: opt.value
    }, ((_ref2 = (opt === null || opt === void 0 ? void 0 : opt.subOptions) || []) === null || _ref2 === void 0 ? void 0 : _ref2.length) > 0 ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(SingleRadioWithSubOptions, _extends({}, props, {
      opt: opt,
      active: ((_opt$subOptions6 = opt.subOptions) === null || _opt$subOptions6 === void 0 ? void 0 : _opt$subOptions6.findIndex(function (subOpt) {
        return subOpt.value === value;
      })) !== -1,
      onChange: onChange
    }))) : /*#__PURE__*/React.createElement(RadioButton, _extends({}, opt, {
      textStyle: opt.textStyle,
      key: opt.value,
      name: name,
      label: opt.label || opt.value,
      value: opt.value,
      checked: value === opt.value,
      disabled: 'disabled' in opt ? opt.disabled : disabled,
      onClick: function onClick(e) {
        console.log('e---', e);
        onChange(opt.value, e);
      }
    })));
  }));
};